/* @refresh reload */
import { render } from 'solid-js/web';
import WebApp from '@twa-dev/sdk';
import './index.css';
import './env';
import App from './App';
import { setupTG } from './utils';

const root = document.getElementById('root');

window.webapp = WebApp;

setupTG();

if (import.meta.env.DEV) {
  import('@/mock');
}

if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
  throw new Error(
    'Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?'
  );
}

WebApp.ready();
WebApp.setHeaderColor('#0A0A0A');
WebApp.setBackgroundColor('#0A0A0A');
WebApp.expand();
render(() => <App />, root!);

declare global {
  interface Window {
    webapp: typeof WebApp;
  }

  interface ImportMetaEnv {
    VITE_ENV: 'DEV' | 'TEST' | 'PROD';
  }
}
